<div class="panel-body">
  <div id="print-recomendacao">
    <div class="print" ng-if="recomendacaoSemeadura.logo">
      <p class="text-right">
        <img ng-src="{{recomendacaoSemeadura.logo}}" width="100">
      </p>
    </div>
    <div class="title-recomendacoes">
      Recomendação de Semeadura
    </div>
    <h2>Sementes</h2>
    <table class="table table-striped table-condensed">
      <thead>
        <tr>
          <th>Talhão</th>
          <th>Área</th>
          <th>Cultivar</th>
          <th class="text-center" colspan="2">Período Ideal</th>
          <th class="text-center">Tempo</th>
          <th ng-if="!recomendacaoSemeadura.data.cobertura">Dens. Ideal</th>
          <th ng-if="!recomendacaoSemeadura.data.cobertura">PG</th>
          <th ng-if="!recomendacaoSemeadura.data.cobertura" class="text-center">Densidade</th>
          <th ng-if="!recomendacaoSemeadura.data.cobertura" class="text-danger text-center">Regulagem</th>
          <th ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura">PMS</th>
          <th colspan="2" class="text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca">
            Qtd
            <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">kg/ha</span>
          </th>
          <th class="text-center" ng-if="!recomendacaoSemeadura.data.calculo_margem_seguranca">
            Qtd
            <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">kg/ha</span>
          </th>
          <th>
            Total
            <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">(kg)</span>
          </th>
          <th>Ciclo</th>
          <th>Colheita</th>
        </tr>
        <tr class="bg-info">
          <td colspan="3"></td>
          <td class="text-center"><strong>Início</strong></td>
          <td class="text-center"><strong>Fim</strong></td>
          <td class="text-center"><strong>em dias</strong></td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura" class="text-center">pl/ha</td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura" class="text-center">%</td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura" class="text-center"><strong>Corrigida</strong></td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura" class="text-danger text-center"><strong>{{recomendacaoSemeadura.data.regulagem || 10}}m</strong></td>
          <td ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura"></td>
          <td class="text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca"><strong>Min</strong></td>
          <td class="text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca"><strong>Máx</strong></td>
          <td ng-if="!recomendacaoSemeadura.data.calculo_margem_seguranca"></td>
          <td colspan="3"></td>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="rec in recomendacaoSemeadura.sortedGlebas() track by $index">
          <td>{{rec.gleba.descricao}}</td>
          <td>{{rec.area_aplicada | number:2}}ha</td>
          <td>{{rec.cultivar.descricao}}</td>
          <td class="text-center">{{rec.data_inicio | date:'dd/MM'}}</td>
          <td class="text-center">{{rec.data_fim_min | date:'dd/MM'}} <br> {{rec.data_fim_max | date:'dd/MM'}}</td>
          <td class="text-center">{{rec.duracao_min | number:2}} <br> {{rec.duracao_max | number:2}}</td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura">{{rec.densidade | number}}</td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura">{{rec.pg}}</td>
          <td ng-if="!recomendacaoSemeadura.data.cobertura" class="text-center">{{rec.densidade_corrigida | number}}</td>
          <td class="text-danger text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca">
            {{rec.regulagem.minima | number:1}} a {{rec.regulagem.maxima | number:1}} <br>
            <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">{{rec.regulagem.minimaEmGramas | number:1}} a {{rec.regulagem.maximaEmGramas | number:1}}g</span>
          </td>
          <td class="text-danger text-center" ng-if="!recomendacaoSemeadura.data.calculo_margem_seguranca && !recomendacaoSemeadura.data.cobertura">
            {{rec.regulagem.resultado | number:1}} <br>
            <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">{{rec.regulagem.resultadoEmGramas | number:1}}g</span>
          </td>
          <td ng-if="!recomendacaoSemeadura.isCulturaPorUnidade && !recomendacaoSemeadura.data.cobertura">{{rec.pms}}</td>
          <td class="text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca">
            {{rec.quantidade.minima | number:2}}
            <span ng-if="recomendacaoSemeadura.isCulturaPorUnidade">{{ rec.cultivar.unidade.abreviatura.trim() }}/ha</span>
          </td>
          <td class="text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca">
            {{rec.quantidade.maxima | number:2}}
            <span ng-if="recomendacaoSemeadura.isCulturaPorUnidade">{{ rec.cultivar.unidade.abreviatura.trim() }}/ha</span>
          </td>
          <td class="text-center" ng-if="!recomendacaoSemeadura.data.calculo_margem_seguranca">
            {{rec.quantidade.resultado | number:2}}
            <span ng-if="recomendacaoSemeadura.isCulturaPorUnidade">{{ rec.cultivar.unidade.abreviatura.trim() }}/ha</span>
          </td>
          <td>{{rec.total.total | number:2}}</td>
          <td>{{rec.ciclo}}</td>
          <td>{{rec.colheita | date:'dd/MM/yyyy'}}</td>
        </tr>
      </tbody>
    </table>

    <div ng-if="recomendacaoSemeadura.data.tratamentos.length">
      <h2>Tratamento de sementes</h2>
      <div ng-repeat="tratamento in recomendacaoSemeadura.data.tratamentos track by $index">
        <table class="table table-striped table-condensed no-margin">
          <thead>
            <tr>
              <th class="resumo-tratamento-col-name">Cultivar de Origem</th>
              <th class="resumo-tratamento-col-name">Cultivar de Destino</th>
              <th class="resumo-tratamentoc-col-value" colspan="2">
                Qtde
                <span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">(kg)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{tratamento.cultivar.descricao}}</td>
              <td>{{tratamento.cultivarDestino.descricao}}</td>
              <td colspan="2">{{tratamento.totalKg | number:2}}</td>
            </tr>
          </tbody>
        </table>
        <div class="print-table-insumo">
          <table class="table table-striped table-condensed">
            <thead>
              <tr>
                <th class="resumo-tratamento-col-name">Insumo</th>
                <th class="resumo-tratamento-col-value">Dose</th>
                <th class="resumo-tratamento-col-value">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="produto in tratamento.insumos track by $index">
                <td>{{produto.descricao}}</td>
                <td>{{produto.dose | number:3}} {{produto.unidadeSelected.abreviatura}}/{{recomendacaoSemeadura.isCulturaPorUnidade? 'un' : '100kg'}}</td>
                <td>{{recomendacaoSemeadura.totalInsumoPorCultivar(produto, tratamento) | number: 3}} {{produto.unidadeSelected.abreviatura}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h3>Total de insumos</h3>
      <table class="table table-striped table-condensed no-margin">
        <thead>
          <tr>
            <th class="resumo-tratamento-col-name">Insumo</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="insumo in recomendacaoSemeadura.reducedInsumos track by insumo.descricao">
            <td>{{insumo.descricao}}</td>
            <td>{{insumo.total | number:2}} {{insumo.unidade}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div ng-if="recomendacaoSemeadura.data.adubacao.length">
      <h2>Adubos</h2>
      <table class="table table-striped table-condensed">
        <thead>
          <tr>
            <th>Talhão</th>
            <th>Adubo</th>
            <th ng-if="!recomendacaoSemeadura.data.cobertura" class="text-danger text-center">Regulagem ({{recomendacaoSemeadura.data.regulagem_adubacao || 10}}m)</th>
            <th>Dose</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="adubo in recomendacaoSemeadura.data.adubacao track by $index">
            <td>{{adubo.gleba.descricao}}</td>
            <td>{{adubo.adubo.descricao}}</td>
            <td class="text-danger text-center" ng-if="recomendacaoSemeadura.data.calculo_margem_seguranca">
              <!--considerar conversão para gramas = 1000g para exibição -->
              {{adubo.regulagem_adubacao.minima * 1000.0 | number}} a {{adubo.regulagem_adubacao.maxima * 1000.0 | number}} g
            </td>
            <td class="text-danger text-center" ng-if="!recomendacaoSemeadura.data.calculo_margem_seguranca && !recomendacaoSemeadura.data.cobertura">
              <!--considerar conversão para gramas = 1000g para exibição -->
              {{adubo.regulagem_adubacao.resultado * 1000 | number}} g
            </td>
            <td>{{adubo.dose | number}} {{adubo.adubo.unidade.abreviatura.trim() | lowercase}}/ha</td>
            <td>{{adubo.total | number}} {{adubo.adubo.unidade.abreviatura.trim() | lowercase}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="print">
      <p>
        <strong>Propriedade:</strong> {{recomendacaoSemeadura.data.propriedade.descricao}} <br>
        <strong>Safra:</strong> {{recomendacaoSemeadura.data.safra.descricao}} <br>
        <strong>Cultura</strong> {{recomendacaoSemeadura.data.cultura.descricao}}
      </p>
      <div ng-if="recomendacaoSemeadura.data.observacao">
        <p>
          <strong>Observação:</strong> <br>
          <strong>{{recomendacaoSemeadura.data.observacao}}</strong>
        </p>
      </div>
      <div class="signatures">
        <print-signature
          label="Recomendante"
          name="recomendacaoSemeadura.data.usuario ? recomendacaoSemeadura.data.usuario.nome_completo : $root.currentUser.nome_completo"
        ></print-signature>
        <print-signature label="Responsável"></print-signature>
      </div>
    </div>
  </div>
</div>
